import { SortDirectionEnum } from "~/__generated__/graphql"
import { cn } from "~/common/shadcn-utils"
import { Button } from "~/shadcn/ui/button"

import ArrowDownIcon from "~/images/icons/arrow-down.svg?react"
import ArrowUpIcon from "~/images/icons/arrow-up.svg?react"

export const SortableColumnHeader = ({
  onClick,
  sortDir,
  isActiveSort,
  children,
}: {
  onClick: () => void
  sortDir: SortDirectionEnum
  isActiveSort: boolean
  children: React.ReactNode
}) => {
  return (
    <>
      <div className="lg:hidden">{children}</div>
      <Button
        onClick={onClick}
        variant="ghost"
        size="none"
        className={cn(
          "hidden lg:flex font-semibold text-left justify-start hover:bg-transparent",
          {
            "min-w-[60px]": isActiveSort,
          }
        )}
      >
        <span>{children}</span>
        {isActiveSort && (
          <span className="ml-1">
            {sortDir === SortDirectionEnum.Asc ? (
              <ArrowDownIcon />
            ) : (
              <ArrowUpIcon />
            )}
          </span>
        )}
      </Button>
    </>
  )
}
